import React, { createContext, useContext, useMemo, useState } from "react";

import { LifePlan, PlanCost } from "Utils/types";

import { useModal } from "Cobalt/Modal";

interface OpenEnrollmentModalProps {
  plan: LifePlan;
  planCost: PlanCost;
}
interface LifeContextProps {
  openEnrollmentModal: (props: OpenEnrollmentModalProps) => void;
  plan: LifePlan | null;
  planCost: PlanCost | null;
  isShowing: boolean;
  hideEnrollmentModal: () => void;
}

const LifeContext = createContext<LifeContextProps>({
  openEnrollmentModal: () => {},
  plan: null,
  planCost: null,
  isShowing: false,
  hideEnrollmentModal: () => {},
});

interface OpenEnrollmentModalProps {
  plan: LifePlan;
  planCost: PlanCost;
}
export const LifeContextProvider = ({ children }) => {
  const { show, hide, isShowing } = useModal();
  const [_plan, _setPlan] = useState<LifePlan | null>(null);
  const [_planCost, _setPlanCost] = useState<PlanCost | null>(null);
  const contextValue = useMemo(() => {
    const openEnrollmentModal = ({ plan, planCost }: OpenEnrollmentModalProps) => {
      _setPlan(plan);
      _setPlanCost(planCost);
      show();
    };
    const hideEnrollmentModal = () => {
      _setPlan(null);
      _setPlanCost(null);
      hide();
    };

    return { openEnrollmentModal, plan: _plan, planCost: _planCost, isShowing, hideEnrollmentModal };
  }, [_plan, _planCost, isShowing, show, hide]);

  return <LifeContext.Provider value={contextValue}>{children}</LifeContext.Provider>;
};

export const useLifeContext = () => useContext(LifeContext);
